import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { SalesRes } from 'features/sales'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchSales = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: sales,
		isLoading: isSalesLoading,
		isSuccess: isSalesSuccess
	} = useQuery<SalesRes>({
		queryKey: queryKeys.sales.list(`booking_id=${params.id}`),
		queryFn: () => axiosPrivate.get(apiRoutes.sales(`booking_id=${params.id}`)),
		enabled: !!auth.accessToken
	})

	return {
		sales,
		isSalesLoading,
		isSalesSuccess
	}
}
